// extracted by mini-css-extract-plugin
module.exports = {"items":"styles_items__2f7Zb","item":"styles_item__1szzJ","mobile":"styles_mobile__24r04"};